import styled from "styled-components"
import { scale, breakpoint, colors } from "../../styles"
import { space, SpaceProps } from "../../styles/styled-system"

interface ScrollPanelStyledProps {
	scrollAuto?: boolean
}

interface ScrollPanelInnerStyledProps {
	paddingAdjustment?: number
}

export const ScrollPanelStyled = styled.div<ScrollPanelStyledProps>`
	width: 100%;
	margin: 0 auto;
	scroll-behavior: ${(props) => (props.scrollAuto ? "smooth" : "auto")};
	overflow: ${(props) => (props.scrollAuto ? "auto" : "hidden")};
	padding-bottom: ${scale.px(2)};
`

ScrollPanelStyled.defaultProps = {
	scrollAuto: false,
}

export const Inner = styled.div<ScrollPanelInnerStyledProps>`
	${breakpoint("l")<ScrollPanelInnerStyledProps>`
		padding-left: ${(props) => `calc(50vw - ${scale.px(props.paddingAdjustment)})`};
	`}
`

interface NavButtonProps extends SpaceProps {
	disabled?: boolean
}

export const NavButton = styled.button<NavButtonProps>`
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: ${colors.navy};
	border-radius: 50%;
	width: ${scale.px(5)};
	height: ${scale.px(5)};

	transition: opacity 0.25s;
	:disabled {
		opacity: 0.5;
	}
	${space}
`

NavButton.defaultProps = {
	disabled: false,
}
